import {css} from 'styled-components';

import {getColor} from '@yourcoach/shared/styles/utils';

export const link = css`
  text-decoration: none;
  color: ${getColor('text3')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &.active {
    color: ${getColor('lostColors.sashaGray')};
    pointer-events: none;
  }

  &:hover {
    color: ${getColor('text4')};
  }
`;
